import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Icon,
} from "@mui/material";
import { useForm } from "react-hook-form";

import React from "react";
import FormProvider from "../../../components/FormProviders";
import SoftButton from "../../../components/SoftButton";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import _ from "lodash";
import { useDisclosure } from "../../../hooks/useDisclosure";
import SoftTypography from "../../../components/SoftTypography";
import SoftBox from "../../../components/SoftBox";
import pxToRem from "../../../assets/theme/functions/pxToRem";
import PropTypes from "prop-types";
import { useDeleteCredential } from "../hooks";

const DeleteCredentialModal = ({ id }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  // hooks
  const { mutate: deleteCredential, isLoading } = useDeleteCredential();

  //form provider
  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = () => {
    deleteCredential(id, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <>
      <IconButton size="small" onClick={onOpen}>
        <Icon sx={{ fontWeight: "bold" }} color="error">
          delete
        </Icon>
      </IconButton>
      <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Delete Credential</DialogTitle>
          <DialogContent>
            <SoftBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <SoftBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    flexDirection={{ xs: "column", sm: "row" }}
                  >
                    <SoftBox display="flex" alignItems="center">
                      <CancelRoundedIcon
                        sx={{
                          width: pxToRem(48),
                          height: pxToRem(48),
                          color: (theme) => theme.palette.error.main,
                        }}
                      />

                      <SoftBox ml={2} lineHeight={0}>
                        <SoftTypography variant="h6" fontWeight="medium">
                          Delete Credential
                        </SoftTypography>
                        <SoftTypography variant="button" color="text" fontWeight="regular">
                          Are you sure you want to delete this credential? This process is not
                          reverseble.
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </Grid>
              </Grid>
            </SoftBox>
          </DialogContent>
          <DialogActions>
            <SoftButton variant="gradient" sx={{ mt: 2 }} onClick={onClose}>
              Cancel
            </SoftButton>
            <SoftButton
              variant="gradient"
              color="error"
              type="submit"
              sx={{ mt: 2 }}
              disabled={isLoading}
              isLoading={isLoading}
            >
              Delete
            </SoftButton>
          </DialogActions>
        </FormProvider>
      </Dialog>
    </>
  );
};

DeleteCredentialModal.propTypes = {
  id: PropTypes.string,
};

export default DeleteCredentialModal;
